import axios from 'axios';

export class GeoService {
    constructor(apiKey) {
        this.apiKey = apiKey;
    }

    coordinatesForAddress(addressString) {
        const encodedAddress = encodeURI(addressString);
        return axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${encodedAddress}&key=${this.apiKey}`)
            .then(response => {
                if (response && response.data && response.data.results.length > 0) {
                    return response.data.results[0].geometry.location;
                }
                return null;
            });
    }
}

export const geoService = new GeoService('TEST');



// WEBPACK FOOTER //
// ./web/js/services/GeoService.js